// extracted by mini-css-extract-plugin
export default {"button":"ApproveMultipleBtn_button__UlP9c"};